export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5115.e09cd903.jpg";